export const isSticking = (node: HTMLElement) =>
  node?.getBoundingClientRect().y <= 0
